import clsx from "clsx";
import { useNavigate, useParams } from "react-router-dom";
import { Progress } from "../../../shared/src/components/progress";
import translate from "../locales";
import { useRef } from "react";

export function TellitPage({ handleSave, children, className }) {
  const navigate = useNavigate();
  const { theme } = useParams();
  const formRef = useRef(null);

  return (
    <>
      <div className="intro">
        <div className="intro__container">
          <Progress
            onBackButton={() => navigate("/")}
            step={1}
            title={translate([theme, "name"])}
            prevAria={translate(["general", "prev_page_aria"])}
            className="intro__progress"
          />
          <h1 className="intro__title">{translate([theme, "name"])}</h1>
          <p className="intro__text">{translate([theme, "intro"])}</p>
        </div>
      </div>
      <form
        action=""
        onSubmit={handleSave}
        className={clsx(className, "tellit-form")}
        data-theme={theme}
        ref={formRef}
      >
        <div className="tellit-form__container">{children}</div>
      </form>
    </>
  );
}
